import { Impedimentos } from "@/types/contratacao/impedimentos";
import { FiltrosImpedidos } from '@/types/contratacao/filtros-impedidos';
import { Service } from '../mainService'
import { PortalError } from "@/types/portal-error";

const impedidosService = {
    // filtros
    getCombosConsultaImpedidos,
    getUnidadesGestoras,
    // ações
    getImpedimentoId,
    consultarImpedidos,
    salvarImpedimento,
    alterarImpedimento,
    salvarSuspensao,
    excluirSuspensao,
    baixarAnexoImpedimento,
    baixarAnexoSuspensao,
}

async function getCombosConsultaImpedidos() {
    try {
        const tiposImpedimento = await Service.$http.get(process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/tiposImpedimento");
        return {
            tiposImpedimento: tiposImpedimento.data,
        };
    } catch (e: any) {
        return e.response;
    }
}

async function getUnidadesGestoras() {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/unidadesgestoras");
        return response.data
    } catch (e: any) {
        return e.response;
    }
}

async function getImpedimentoId(idImpedimento: string) {
    try {
        const resp = await Service.$http.get(process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/impedimentoById/" + idImpedimento)

        const impedimento = new Impedimentos(resp.data)
        //impedimento.tratarDadosDaAPI()
        return impedimento
    } catch (e: any) {
        return e.response;
    }
}

async function consultarImpedidos(filtros: FiltrosImpedidos, page: number) {
    try {
        const parametros = `?page=${page}&pageSize=10${filtros.toQueryString()}`
        const resp = await Service.$http.get(process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/impedimentos" + parametros)
        return resp
    } catch (e: any) {
        return e.response;
    }
}

async function salvarImpedimento(impedimento: Impedimentos) {

    try {
        const response = await Service.$http.post(process.env.VUE_APP_CONTRATACOES_API + "/Impedimento", impedimento.toFormData(), {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function alterarImpedimento(idImpedimento: string, impedimento: Impedimentos) {
    try {
        const impedimentoAtualizado = Object.assign(new Impedimentos(), impedimento)
        impedimentoAtualizado.arquivoSuspensao = null
        const response = await Service.$http.patch(process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/alterarImpedimento/" + idImpedimento,
            impedimentoAtualizado.toFormData(), {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function salvarSuspensao(idImpedimento: string, impedimento: any) {
    const data = new FormData()
    data.append("dtSuspensao", impedimento.suspensao.DtSuspensao.toISOString())
    data.append("anoProtSuspensao", impedimento.suspensao.NrAnoprotocoloSuspensao)
    data.append("nrProtSuspensao", impedimento.suspensao.NrProtocoloSuspensao)
    data.append("arquivo", impedimento.arquivo)

    try {
        const url = process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/suspenderImpedimento/" + idImpedimento
        const response = await Service.$http.patch(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function excluirSuspensao(idImpedimento: string, suspensao: any) {
    const data = new FormData()
    data.append("dtSuspensao", "")
    data.append("anoProtSuspensao", "")
    data.append("nrProtSuspensao", "")
    data.append("arquivo", "")
    try {
        const url = process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/cancelarSuspensao/" + idImpedimento
        const response = await Service.$http.patch(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    }
    catch (e: any) {
        console.error('capotou no service', e)
        return e.response;
    }
}

async function baixarAnexoImpedimento(id) {
    const response = await Service.$http.get(
        process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/download/" + id,
        { responseType: "blob" }
    );
    if (response && response.status === 200) return response
    throw new PortalError("Falha ao tentar fazer download do anexo de impedimento.");
}

async function baixarAnexoSuspensao(id) {

    const response = await Service.$http.get(
        process.env.VUE_APP_CONTRATACOES_API + "/Impedimento/downloadSuspensao/" + id,
        { responseType: "blob" }
    );
    if (response && response.status === 200) return response;
    throw new PortalError("Falha ao tentar fazer download do anexo de suspensão.");

}

export default impedidosService;
